import styles from './hamsterGame.module.scss';
import { useGetHamsterGameCode } from '../lib/use-get-hamster-game-code';
import { useGetFocusByRef } from '../lib/use-focus-by-ref';

function HamsterGame() {
  const hamsterGameSourceCode = useGetHamsterGameCode();
  const iframeElement = useGetFocusByRef();

  return (
    <iframe
      ref={iframeElement}
      className={styles.iframe}
      srcDoc={hamsterGameSourceCode}
      title="Hamster Game"
    />
  );
}

export default HamsterGame;
